module.exports = __webpack_public_path__ + "static/community-5-b1e078070fa695f99d35df6d4fe845b1.png";